
import Description from '../../components/Description/Description';
import LivingConditionField from '../../components/LivingConditionField/LivingConditionField';
import NumericField from '../../components/NumericField/NumericField';
import PagesFooter from '../../components/PagesFooter/PagesFooter';
import PagesHeader from '../../components/PagesHeader/PagesHeader';
import ShowDetailsModal from '../../components/ShowDetailsModal/ShowDetailsModal';
import Title from '../../components/Title/Title';
import { usePagesContext } from '../../context/PagesContext';
import { scrollToFieldWithError } from '../../helpers/scrollToFieldWithError';
import { useAppDispatch } from '../../hooks';
import useComponentTracker from '../../hooks/useComponentTracker';
import useDefaultPagesAction from '../../hooks/useDefaultPagesAction';
import usePagesConfig from '../../hooks/usePagesConfig';
import useSetBannerType from '../../hooks/useSetBannerType';
import useTranslation from '../../hooks/useTranslation';
import useValidation from '../../hooks/useValidation';
import { addOrUpdateFormField } from '../../store/applicationform';
import { WizardPageAction } from '../../store/wizard/wizard';

const LivingConditionPage = () => {
    useComponentTracker('LivingConditionPage');

    const dispatch = useAppDispatch();
    const translate = useTranslation();
    const { totalSections, totalAboutYouPages } = usePagesConfig();
    const { currentPage } = usePagesContext();
    const defaultPagesAction = useDefaultPagesAction();
    const validationErrors = useValidation(['applicantMaritalStatus', 'applicantNumberChildrenNotOfAge']);

    useSetBannerType('bannerOne');

    const onAction = async (action: WizardPageAction) => {
        if (action === 'next' && validationErrors.length) {
            scrollToFieldWithError(validationErrors);
            validationErrors.forEach((validationError) => {
                dispatch(addOrUpdateFormField(validationError));
            });
            return false;
        }

        return defaultPagesAction(action);
    };

    return (
        <>
            <PagesHeader
                actions={['back']}
                onAction={onAction}
                currentPage={currentPage}
                currentSection={0}
                numberOfSections={totalSections}
                numberOfPagesInSection={totalAboutYouPages}
                currentPageInSection={currentPage}
                sectionTitle={translate('field.section.about-you')}
            />
            <Title text={translate('page.living-condition.title')} />
            <Description text={translate('page.living-condition.description')} />
            <ShowDetailsModal
                label={translate('dialog.know-more.label')}
                dialogTitle={translate('dialog.know-more.label')}
                dialogContent={translate('dialog.living-condition.content')}
            />
            <LivingConditionField name="applicantMaritalStatus" />
            <NumericField
                name="applicantNumberChildrenNotOfAge"
                label={translate('page.living-condition.subtitle.children')}
                min={0}
                max={20}
            />
            <PagesFooter
                actions={['next']}
                onAction={onAction}
                currentSection={0}
                numberOfSections={totalSections}
                numberOfPagesInSection={totalAboutYouPages}
                currentPageInSection={currentPage}
                sectionTitle={translate('field.section.about-you')}
            />
        </>
    );
};

export default LivingConditionPage;
